import React, { ReactElement, ReactNode } from 'react';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export interface PlaceholderAnimProps {
  className?: string;
  children?: ReactNode;
}

export function PlaceholderAnim (
  props: PlaceholderAnimProps
): ReactElement {
  const { children, className } = props;
  return (
    <Container className={className}>
      { children }
    </Container>
  );
}

const placeholderAnim = keyframes`
  0% {
    transform: translate3d(-30%, 0, 0);
  }
  100% {
    transform: translate3d(30%, 0, 0);
  }
`;

const Container = styled.div`
  position: relative;
  display: block;
  overflow: hidden;
  ${({ theme }) => css`
    color: ${theme.content.base5};
    background-color: ${theme.content.base5};
  `}
  &:after {
    content: '\\00a0';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 50%;
    z-index: 1;
    width: 500%;
    margin-left: -250%;
    animation: ${placeholderAnim} 0.8s linear infinite;
    background: linear-gradient(to right,
      rgba(255, 255, 255, 0) 44%,
      rgba(255, 255, 255, .35) 50%,
      rgba(255, 255, 255, 0) 56%) 50% 50%;
  }
`;
